"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var windowStage;
(function (windowStage) {
    windowStage["DEFAULT"] = "DEFAULT";
    windowStage["FULLSCREEN"] = "FULLSCREEN";
    windowStage["MINIMIZED"] = "MINIMIZED";
})(windowStage = exports.windowStage || (exports.windowStage = {}));
//# sourceMappingURL=StageEnum.js.map


//////////////////
// WEBPACK FOOTER
// /Users/larsmarin/Documents/Workspaces/AAG/aag-amc-projects/~/.pnpm/@progress+kendo-react-dialogs@3.18.0_react-dom@16.14.0_react@16.14.0__react@16.14.0/~/@progress/kendo-react-dialogs/dist/npm/StageEnum.js
// module id = 322
// module chunks = 0